import type { Tables } from "../types";

/**
 * The seconds a contract asks of one working day: the week's hours spread over the days it
 * schedules. A record scheduling no days at all asks nothing, rather than dividing by zero.
 *
 * @param employment - The contract in force on the day.
 * @returns The day's target in whole seconds.
 */
export function getEmploymentDailyTargetSeconds(employment: Tables<"employments">): number {
	if (!employment.workdays.length) return 0;
	return Math.round((employment.hoursPerWeek / employment.workdays.length) * 3600);
}
